import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { useGetCities } from "@/api/cities.api";
import { UserFormValues } from "@/pages/user/user-form";

interface ClientAccessFieldsProps {
  control: Control<UserFormValues>;
}

// Shown when a user's role is CLIENT: the collections (cities) their dashboard
// is scoped to. QR access is derived from the selected collections.
const ClientAccessFields: FC<ClientAccessFieldsProps> = ({ control }) => {
  const { data: cities } = useGetCities();

  return (
    <>
      <Controller
        control={control}
        name="allowedCities"
        render={({ field }) => {
          const value: number[] = (field.value ?? [])
            .map((v: number | { id: number }) =>
              typeof v === "number" ? v : v?.id,
            )
            .filter((v: number | undefined): v is number => v != null);
          return (
            <FormControl margin="normal" fullWidth>
              <InputLabel id="allowed-cities-label">
                Collections autorisées
              </InputLabel>
              <Select
                labelId="allowed-cities-label"
                multiple
                value={value}
                onChange={(e) => field.onChange(e.target.value)}
                input={<OutlinedInput label="Collections autorisées" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {(selected as number[]).map((id) => (
                      <Chip
                        key={id}
                        size="small"
                        label={cities.find((c) => c.id === id)?.name ?? id}
                      />
                    ))}
                  </Box>
                )}
              >
                {cities.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }}
      />
    </>
  );
};

export default ClientAccessFields;
